import styled, { css } from 'styled-components';
import convertHexToRgba from '~/helpers/convertHexToRgba';

export const ConsumerLabelModalStyled = styled.div.attrs({
  className: 'consumer-label-screen',
})`
  ${({ theme }) => {
    const { colors, media } = theme;
    return css`
      background-color: ${colors.primary.white};
      box-shadow: 0 20px 40px 0 ${convertHexToRgba(colors.primary.black, 0.25)};
      max-width: 1380px;
      width: 60vw;
      display: flex;
      flex-direction: column;
      padding: 48px 16px 16px;
      border-radius: 32px;
      position: relative;
      text-align: center;

      ${media.tablet.only} {
        width: 96vw;
      }

      ${media.mobile.down} {
        width: 90vw;
        padding: 10% 8%;
      }

      .icon--fill-close-thin {
        fill: ${colors.secondary.gray};
        height: 16px;
        position: absolute;
        right: 1.5rem;
        top: 1.5rem;
        cursor: pointer;
      }

      .consumer-label__modal {
        height: 90vh;

        iframe {
          width: 100%;
          height: 100%;
        }
      }
    `;
  }}
`;
